let elements = {
  pick: 1,
  shuffle: false,
  questionElementHeight: 800,
  questionHeight: 470,
  answerHeight: 170,
  items: [
    {
      shuffle: false,
      // pick: 10,
      // questionElementHeight: 1100,
      questionsList: [
        {
          questionElementHeight: 200,
          questionHeight: 100,
          answerHeight: 60,
          question: 'Jak wygląda kursor?',
          shuffle: true,
          // vertical: true,
          answers: [
            {
              text: '<img src="' + require('./img/01kursor.png') + '" width="30px"/>',
              imagePath: 'games/page026_game1/img/01kursor.png',
              correct: true,
            },
            {
              text: '<img src="' + require('./img/01zamknij.png') + '" width="60px"/>',
              imagePath: 'games/page026_game1/img/01zamknij.png',
            },
            {
              text: '<img src="' + require('./img/01folder.png') + '" width="60px"/>',
              imagePath: 'games/page026_game1/img/01folder.png',
            },
          ],
        },
        {
          questionElementHeight: 300,
          questionHeight: 100,
          answerHeight: 200,
          question: 'Które dziecko siedzi prawidłowo przy komputerze?',
          shuffle: true,
          // vertical: true,
          answers: [
            {
              text: '<img src="' + require('./img/021.png') + '" width="180px"/>',
              imagePath: 'games/page026_game1/img/021.png',
              correct: true,
            },
            {
              text: '<img src="' + require('./img/022.png') + '" width="180px"/>',
              imagePath: 'games/page026_game1/img/022.png',
            },
            {
              text: '<img src="' + require('./img/023.png') + '" width="180px"/>',
              imagePath: 'games/page026_game1/img/023.png',
            },
          ],
        },
        {
          questionElementHeight: 300,
          questionHeight: 100,
          answerHeight: 200,
          question: 'Które zdjęcie przedstawia klawiaturę?',
          shuffle: true,
          // vertical: true,
          answers: [
            {
              text: '<img src="' + require('./img/03jednostka.png') + '" width="100px"/>',
              imagePath: 'games/page026_game1/img/03jednostka.png',
            },
            {
              text: '<img src="' + require('./img/03klawiatura.png') + '" width="200px"/>',
              imagePath: 'games/page026_game1/img/03klawiatura.png',
              correct: true,
            },
            {
              text: '<img src="' + require('./img/03monitor.png') + '" width="200px"/>',
              imagePath: 'games/page026_game1/img/03monitor.png',
            },
          ],
        },
        {
          questionElementHeight: 200,
          questionHeight: 100,
          answerHeight: 100,
          question: 'Jak wygląda ikona programu Paint?',
          shuffle: true,
          // vertical: true,
          answers: [
            {
              text: '<img src="' + require('./img/04paint.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/04paint.png',
              correct: true,
            },
            {
              text: '<img src="' + require('./img/04scratch.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/04scratch.png',
            },
            {
              text: '<img src="' + require('./img/04word.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/04word.png',
            },
          ],
        },
        {
          questionElementHeight: 200,
          questionHeight: 100,
          answerHeight: 100,
          question: 'Które narzędzie służy do kolorowania rysunków w programie Paint? Wskaż jego ikonę.',
          shuffle: true,
          // vertical: true,
          answers: [
            {
              text: '<img src="' + require('./img/05wypelniijkolorem.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/05wypelniijkolorem.png',
              correct: true,
            },
            {
              text: '<img src="' + require('./img/05gumka.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/05gumka.png',
            },
            {
              text: '<img src="' + require('./img/05lupa.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/05lupa.png',
            },
          ],
        },
        {
          questionElementHeight: 200,
          questionHeight: 100,
          answerHeight: 100,
          question: 'Którym narzędziem programu Paint można narysować domek? Wskaż jego ikonę.',
          shuffle: true,
          // vertical: true,
          answers: [
            {
              text: '<img src="' + require('./img/06gumka.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/06gumka.png',
            },
            {
              text: '<img src="' + require('./img/06ołówek.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/06ołówek.png',
              correct: true,
            },
            {
              text: '<img src="' + require('./img/06zaznacz.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/06zaznacz.png',
            },
          ],
        },
        {
          questionElementHeight: 300,
          questionHeight: 100,
          answerHeight: 200,
          question: 'Folder to',
          shuffle: true,
          vertical: true,
          answers: [
            {
              text: 'komputerowa teczka, w której znajdują się pliki.',
              correct: true,
            },
            {
              text: 'mały obrazek, który symbolizuje program.',
            },
            {
              text: 'obszar roboczy na ekranie komputera.',
            },
          ],
        },
        {
          questionElementHeight: 300,
          questionHeight: 100,
          answerHeight: 200,
          question: 'Aby skopiować rysunek w programie Paint, należy wcisnąć klawisze',
          shuffle: true,
          // vertical: true,
          answers: [
            {
              text:
                '<img src="' +
                require('./img/ctrl.png') +
                '" height="70px"/> + <img src="' +
                require('./img/c.png') +
                '" height="70px"/>.',
              imagePath: 'games/page026_game1/img/08ctrlC.png',
              correct: true,
            },
            {
              text:
                '<img src="' +
                require('./img/ctrl.png') +
                '" height="70px"/> + <img src="' +
                require('./img/v.png') +
                '" height="70px"/>.',
              imagePath: 'games/page026_game1/img/08ctrlV.png',
            },
            {
              text: '<img src="' + require('./img/08enter.png') + '" width="180px"/>.',
              imagePath: 'games/page026_game1/img/08enter.png',
            },
          ],
        },
        {
          questionElementHeight: 200,
          questionHeight: 100,
          answerHeight: 100,
          question: 'Którego narzędzia programu Paint użyjesz do narysowania piłki? Wskaż jego ikonę.',
          shuffle: true,
          // vertical: true,
          answers: [
            {
              text: '<img src="' + require('./img/09gumka.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/09gumka.png',
            },
            {
              text: '<img src="' + require('./img/09owal.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/09owal.png',
              correct: true,
            },
            {
              text: '<img src="' + require('./img/09prostokąt.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/09prostokąt.png',
            },
          ],
        },
        {
          questionElementHeight: 200,
          questionHeight: 100,
          answerHeight: 100,
          question: 'Który obrazek przedstawia obiekt 3D?',
          shuffle: true,
          // vertical: true,
          answers: [
            {
              text: '<img src="' + require('./img/10kula3D.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/10kula3D.png',
              correct: true,
            },
            {
              text: '<img src="' + require('./img/10koło2D.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/10koło2D.png',
            },
            {
              text: '<img src="' + require('./img/10kwadrat2D.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/10kwadrat2D.png',
            },
          ],
        },
        {
          questionElementHeight: 300,
          questionHeight: 100,
          answerHeight: 200,
          question: 'Figury płaskie to',
          shuffle: true,
          // vertical: true,
          answers: [
            {
              text: '<img src="' + require('./img/11kołotrojkatprostokat.png') + '" height="100px"/>.',
              imagePath: 'games/page026_game1/img/11kołotrojkatprostokat.png',
              correct: true,
            },
            {
              text: '<img src="' + require('./img/11szescianprostopadloscian.png') + '" height="130px"/>.',
              imagePath: 'games/page026_game1/img/11szescianprostopadloscian.png',
            },
            {
              text: '<img src="' + require('./img/11kulastozek.png') + '" height="120px"/>.',
              imagePath: 'games/page026_game1/img/11kulastozek.png',
            },
          ],
        },
        {
          questionElementHeight: 200,
          questionHeight: 100,
          answerHeight: 100,
          question: 'Które narzędzie programu Paint służy do usuwania fragmentów rysunku? Wskaż jego ikonę.',
          shuffle: true,
          // vertical: true,
          answers: [
            {
              text: '<img src="' + require('./img/12gumka.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/12gumka.png',
              correct: true,
            },
            {
              text: '<img src="' + require('./img/12pedzel.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/12pedzel.png',
            },
            {
              text: '<img src="' + require('./img/12wypelniijkolorem.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/12wypelniijkolorem.png',
            },
          ],
        },
        {
          questionElementHeight: 200,
          questionHeight: 100,
          answerHeight: 100,
          question: 'Które narzędzie służy do pisania liter i cyfr w programie Paint? Wskaż jego ikonę.',
          shuffle: true,
          // vertical: true,
          answers: [
            {
              text: '<img src="' + require('./img/13tekst.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/13tekst.png',
              correct: true,
            },
            {
              text: '<img src="' + require('./img/13lupa.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/13lupa.png',
            },
            {
              text: '<img src="' + require('./img/13ołówek.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/13ołówek.png',
            },
          ],
        },
        {
          questionElementHeight: 200,
          questionHeight: 100,
          answerHeight: 100,
          question: 'Który program służy do wykonywania obliczeń? Wskaż jego ikonę.',
          shuffle: true,
          // vertical: true,
          answers: [
            {
              text: '<img src="' + require('./img/14kalkulator.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/14kalkulator.png',
              correct: true,
            },
            {
              text: '<img src="' + require('./img/14paint.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/14paint.png',
            },
            {
              text: '<img src="' + require('./img/14word.png') + '" width="80px"/>',
              imagePath: 'games/page026_game1/img/14word.png',
            },
          ],
        },
        {
          questionElementHeight: 200,
          questionHeight: 100,
          answerHeight: 100,
          question: 'Program Word służy głównie do',
          shuffle: true,
          // vertical: true,
          answers: [
            {
              text: 'pisania.',
              correct: true,
            },
            {
              text: 'rysowania.',
            },
            {
              text: 'wykonywania obliczeń.',
            },
          ],
        },
        {
          questionElementHeight: 300,
          questionHeight: 100,
          answerHeight: 200,
          question: 'Aby pisać wielkie litery należy wcisnąć klawisz',
          shuffle: true,
          // vertical: true,
          answers: [
            {
              text: '<img src="' + require('./img/16capsLock.png') + '" height="70px"/>.',
              imagePath: 'games/page026_game1/img/16capsLock.png',
              correct: true,
            },
            {
              text: '<img src="' + require('./img/16enter.png') + '" width="180px"/>.',
              imagePath: 'games/page026_game1/img/16enter.png',
            },
            {
              text: '<img src="' + require('./img/16spacja.png') + '" height="70px"/>.',
              imagePath: 'games/page026_game1/img/16spacja.png',
            },
          ],
        },
        {
          questionElementHeight: 300,
          questionHeight: 100,
          answerHeight: 200,
          question: 'Podczas pisania liter ą, ć, ę, ł, ń, ó, ś, ź, ż należy wcisnąć prawy klawisz',
          shuffle: true,
          // vertical: true,
          answers: [
            {
              text: '<img src="' + require('./img/17alt.png') + '" height="70px"/>.',
              imagePath: 'games/page026_game1/img/17alt.png',
              correct: true,
            },
            {
              text: '<img src="' + require('./img/17enter.png') + '" width="180px"/>.',
              imagePath: 'games/page026_game1/img/17enter.png',
            },
            {
              text: '<img src="' + require('./img/17shift.png') + '" height="70px"/>.',
              imagePath: 'games/page026_game1/img/17shift.png',
            },
          ],
        },
        {
          questionElementHeight: 200,
          questionHeight: 100,
          answerHeight: 100,
          question: 'Scratch służy',
          shuffle: true,
          // vertical: true,
          answers: [
            {
              text: 'do nauki programowania.',
              correct: true,
            },
            {
              text: 'wyłącznie do pisania tekstów.',
            },
            {
              text: 'wyłącznie do rysowania.',
            },
          ],
        },
        {
          questionElementHeight: 300,
          questionHeight: 100,
          answerHeight: 200,
          question: 'Podczas rysowania koła za pomocą narzędzia <i>Owal</i> trzeba trzymać wciśnięty klawisz',
          shuffle: true,
          // vertical: true,
          answers: [
            {
              text: '<img src="' + require('./img/19enter.png') + '" width="180px"/>.',
              imagePath: 'games/page026_game1/img/19enter.png',
            },
            {
              text: '<img src="' + require('./img/19shift.png') + '" height="70px"/>.',
              imagePath: 'games/page026_game1/img/19shift.png',
              correct: true,
            },
            {
              text: '<img src="' + require('./img/19spacja.png') + '" height="70px"/>.',
              imagePath: 'games/page026_game1/img/19spacja.png',
            },
          ],
        },
        {
          questionElementHeight: 300,
          questionHeight: 100,
          answerHeight: 200,
          question: 'Po uruchomieniu edytora Scratch na scenie widoczny jest duszek',
          shuffle: true,
          // vertical: true,
          answers: [
            {
              text: '<img src="' + require('./img/20scratch.png') + '" height="160px"/>.',
              imagePath: 'games/page026_game1/img/20scratch.png',
              correct: true,
            },
            {
              text: '<img src="' + require('./img/20pies.png') + '" height="160px"/>.',
              imagePath: 'games/page026_game1/img/20pies.png',
            },
            {
              text: '<img src="' + require('./img/20mysz.png') + '" height="160px"/>.',
              imagePath: 'games/page026_game1/img/20mysz.png',
            },
          ],
        },
      ],
    },
  ],
};

export default elements;
